import { FunctionComponent } from "react";
import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import HeadingContainer from "../../../layout/heading-container";
import { BodyLargeRegular, TitleLarge } from "../../../components/font";
import { OptionTile, tokens } from "@manifesthhqinc/ui-library";
import { OptionFormContainer } from "../../../layout/container/OptionFormContainer";

const HaveAnotherAccount: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const { currentSourceAccountStep, onClickContinue, addAnotherOldAccount } = props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <HeadingContainer withProgressBar paneVariant="optionForm">
            <TitleLarge>Do you have another old account to transfer?</TitleLarge>
            <BodyLargeRegular $color={tokens.color.text.secondary}>
              Don't worry if you're uncertain about having an old account with a former employer; we can check that for
              you.
            </BodyLargeRegular>
          </HeadingContainer>
          <OptionFormContainer>
            <OptionTile
              variant="clickthrough"
              name="hasAnotherAccount"
              appearance="secondary"
              onClick={addAnotherOldAccount}
            >
              Yes, I do
            </OptionTile>
            <OptionTile
              variant="clickthrough"
              name="hasNoAnotherAccount"
              appearance="secondary"
              onClick={onClickContinue}
            >
              No, I do not
            </OptionTile>
          </OptionFormContainer>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};

export default HaveAnotherAccount;
